var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.show
    ? _c(_setup.ResponsiveModal, {
        attrs: { title: "Attendance", subMenuModal: _vm.subMenuModal },
        on: {
          refresh: function ($event) {
            return _setup.emit("refresh")
          },
          reset: function ($event) {
            return _setup.reset()
          },
        },
        scopedSlots: _vm._u(
          [
            {
              key: "body",
              fn: function () {
                return [
                  _c(
                    "v-list",
                    { staticClass: "flex divide-y", attrs: { dense: "" } },
                    _vm._l(_vm.lesson.students, function (student, i) {
                      return _c(
                        "v-list-item",
                        {
                          key: student.id,
                          staticClass: "pr-0",
                          attrs: { "two-line": "" },
                        },
                        [
                          _c(
                            "v-list-item-content",
                            [
                              _c(
                                "v-list-item-title",
                                [
                                  _c(
                                    _setup.Link,
                                    {
                                      attrs: {
                                        href: `/profile/${student.id}/account`,
                                      },
                                    },
                                    [_vm._v(_vm._s(student.name))]
                                  ),
                                ],
                                1
                              ),
                              _c("v-list-item-subtitle", [
                                _vm._v(
                                  _vm._s(
                                    `${
                                      student.attendance.is_guest
                                        ? student.attendance.purchase_option.name.includes(
                                            "First"
                                          )
                                          ? "First Visit"
                                          : student.attendance.purchase_option
                                              .category == "drop-ins"
                                          ? "Just Visiting"
                                          : "Rescheduled"
                                        : "Enrolled"
                                    }`
                                  )
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex shrink justify-end ma-0" },
                            [
                              _vm.lesson.id && _vm.lesson.type !== "Hold"
                                ? _c("SoliAttendance", {
                                    attrs: {
                                      eventId: _vm.lesson.id,
                                      event: _vm.lesson,
                                      studentId: student.id,
                                      inline: "",
                                      disabled:
                                        !!_vm.lesson.students[i].attendance
                                          .status,
                                      groupStatus:
                                        _vm.lesson.students[i].attendance
                                          .status,
                                    },
                                    on: {
                                      success: function ($event) {
                                        return _setup.emit("showMessage", 300)
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          1601864295
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }